import React from 'react';
import classNames from 'classnames';
import { Cell } from '@/pages/dashboard/components/CommonTable/components/CommonTableCell/Cell';
import { ICategoryCellProps } from '@/pages/dashboard/components/CommonTable/components/CommonTableCell/CategoryCell/type';
import { useLocal } from '@/pages/dashboard/utils/customHook';
import './index.scss';

export const CategoryCell = (props: ICategoryCellProps) => {
  const { className, style, value, config } = props;
  const { valueMapping, column } = config ?? {};
  const { isEN } = useLocal();

  let categoryValues: string[] = [];
  if (Array.isArray(value)) {
    categoryValues = value.map(String);
  } else if (typeof value === 'string') {
    categoryValues = value.split(',').map((v) => v.trim()).filter(Boolean);
  } else if (value !== null && value !== undefined) {
    categoryValues = [String(value)];
  }

  if (categoryValues.length === 0) {
    return (
      <Cell className={classNames('dbd-common-table__category-cell', className)} style={style} config={{ column }}>
        <span>-</span>
      </Cell>
    );
  }

  return (
    <Cell className={classNames('dbd-common-table__category-cell', className)} style={style} config={{ column }}>
      {categoryValues.map((val, index) => {
        const mappingItem = valueMapping?.[val];
        const label = mappingItem
          ? (isEN ? (mappingItem.labelEn ?? mappingItem.label) : (mappingItem.labelCn ?? mappingItem.label)) ?? val
          : val;

        const badgeStyle: React.CSSProperties = {
          color: mappingItem?.color,
          backgroundColor: mappingItem?.backgroundColor,
        };

        return (
          <span
            key={index}
            className={classNames('dbd-common-table__category-cell__badge', {
              'dbd-common-table__category-cell__badge--colored': !!(mappingItem?.color || mappingItem?.backgroundColor),
            })}
            style={badgeStyle}
          >
            {label}
          </span>
        );
      })}
    </Cell>
  );
};
